import React from 'react';
import { Toolbar, AppBar, Typography, Container, Button } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import useReactRouter from 'use-react-router';
const AppMenu = (props) => {
  // console.log('hello', props)
  const history = useHistory();
  const { match } = useReactRouter();

  function goHome() {
    history.push(`/short-online-admission-itn/${match.params.id}`);
  }
  function viewView() {
    history.push(`/short-online-admission-view-itn/${match.params.id}`);
  }   
  // function editView() {
  //   history.push(`/online-admission-edit/${match.params.id}`);
  // }  
  function viewPayment() {
    history.push(`/short-online-admission-payment-itn/${match.params.id}`);
  }


  function downloadForm() {
    history.push(`/short-online-admission-download-itn/${match.params.id}`);
  }

  return (
    <>
      <div style={{ display: "flex", marginBottom: "20px", marginTop: "20px", justifyContent: "center" }}>
        <Button variant="contained" color="primary" style={{ marginRight: "10px",backgroundColor:"#009688" }} onClick={() => goHome()}> Apply</Button>
        {/* <Button variant="contained" color="primary" style={{ marginRight: "10px",backgroundColor:"#009688" }} onClick={() => viewView()}> View</Button> */}
        {/* <Button variant="contained" color="primary" style={{ marginRight: "10px" }} onClick={() => editView()}> Edit</Button> */}
        <Button variant="contained" color="primary" style={{ marginRight: "10px",backgroundColor:"#009688" }} onClick={() => viewPayment()}> Payment</Button>
        <Button variant="contained" color="primary" style={{ marginRight: "10px",backgroundColor:"#009688" }} onClick={() => downloadForm()}> Download</Button>
        
      </div>

    </>
  );
};

export default AppMenu;